'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdTransferWithinAStation = function MdTransferWithinAStation(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm9.6 14.8l-4.6 23.6h3.5l2.9-13.4 3.6 3.4v10h3.4v-12.6l-3.5-3.5 1-5c2.2 2.7 5.4 4.3 9.1 4.3v-3.2c-3.1 0-5.8-1.8-7.3-4.2l-1.5-2.6c-0.6-1.1-1.7-1.6-2.8-1.6-0.4 0-0.9 0.1-1.3 0.2l-8.7 3.6v7.8h3.2v-5.5l3-1.3z m6.3-5.7c-1.8 0-3.4-1.4-3.4-3.2s1.6-3.4 3.4-3.4 3.2 1.6 3.2 3.4-1.4 3.2-3.2 3.2z m16.6 23.8v-2.9l4.1 4.1-4.1 4.3v-3h-9.1v-2.5h9.1z m-5-7h9.1v2.5h-9.1v2.9l-4.1-4.2 4.1-4.2v3z' })
        )
    );
};

exports.default = MdTransferWithinAStation;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/transfer-within-a-station.js
// module id = 3637
// module chunks = 0